import styles from "./edittaskform.module.css";
import { Box, Button, Checkbox, Chip, FormControl, InputLabel, ListItemText, MenuItem, OutlinedInput, Select, TextField } from "@mui/material";
import { Plus, X } from "react-feather";
import { useState } from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { toast } from 'react-smart-toaster';
import { useAuth0 } from "@auth0/auth0-react";
import { Controller, useForm } from "react-hook-form";
import { useEffect } from "react";
import { AddLogCallAPI } from "../../../components/AddLogs";
import { TableLoaderSmall } from "../../../components/LoaderC";
import TaskListCard from "./TaskListCard";
import TaskListCard2 from "./TaskListCard2";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};

const schema = yup.object().shape({
    title: yup.string().required("This field is Required"),
    description: yup.string(),
    property_id: yup.string(),
    technicians: yup.string(),
    days: yup.array()
});

const daysList = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
]

const EditTaskForm = ({ setEditTaskModalOpen, selectedId, setLoading, setSnackbarOpen, setSnackbarMsg, editTaskLocal }) => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [addTaskOpen, setAddTaskOpen] = useState(false);
    const [propertyList, setPropertyList] = useState([]);
    const [allTechnicianList, setAllTechnicianList] = useState([]);
    const [technicianList, setTechnicianList] = useState([]);
    const [selectDays, setSelectDays] = useState([]);
    const [charsLeft, setCharsLeft] = useState({ description: 200 });
    const [taskDetails, setTaskDetails] = useState(null);
    const [prevTaskList, setPrevTaskList] = useState([]);
    const [taskList, setTaskList] = useState([]);
    const [taskVal, setTaskVal] = useState('');
    const [taskError, setTaskError] = useState(false);
    const [activeTaskId, setActiveTaskId] = useState(null);

    const { handleSubmit, control, errors, setValue } = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        defaultValues: {
            title: '',
            description: '',
            property_id: '',
            days: [],
            technicians: ''
        }
    });

    useEffect(() => {
        async function fetchPropertyList() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_CASE_API_URL + "v1/property-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setPropertyList(response.data.data);
            }).catch(() => { });
        }
        fetchPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchPropertyList() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_CASE_API_URL + "v1/technician-list", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setAllTechnicianList(response.data.data);
            }).catch(() => { });
        }
        fetchPropertyList();
    }, [getAccessTokenSilently]);

    useEffect(() => {
        async function fetchTaskDetails() {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + selectedId, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setContentLoading(false);
                setTaskDetails(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }
        if (selectedId)
            fetchTaskDetails();
    }, [selectedId, getAccessTokenSilently]);

    useEffect(() => {
        if (taskDetails) {
            setValue('title', taskDetails?.title);
            setValue('description', taskDetails?.description);
            setValue('property_id', taskDetails?.property_id);
            setValue('description', taskDetails?.description ? taskDetails?.description : '');
            setValue('days', taskDetails?.days);
            setSelectDays(taskDetails?.days);

            setPrevTaskList(taskDetails?.task_list);

            if (taskDetails?.description) {
                setCharsLeft((prev) => {
                    return { ...prev, description: 200 - taskDetails?.description?.length };
                });
            }


            if (taskDetails?.property_id) {
                let technicianListTemp = allTechnicianList?.filter(i => i?.properties?.indexOf(taskDetails?.property_id) > -1);
                setTechnicianList(technicianListTemp);

                setValue('technicians', taskDetails?.technicians);
            }
        }
    }, [taskDetails, allTechnicianList, setValue]);

    const addTask = () => {
        if (taskVal !== '') {
            setAddTaskOpen(false);
            setTaskList(prev => {
                return prev.concat(taskVal);
            })
        } else {
            setTaskError(true);
        }
    }

    const onSubmit = async (data) => {
        setLoading(true);
        setEditTaskModalOpen(false);

        data = { ...data, taskList: taskList, prevTaskList: prevTaskList };

        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        return axios.post(process.env.REACT_APP_CASE_API_URL + "v1/tasks/" + taskDetails?.id, data, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }).then(response => {
            setLoading(false);
            setSnackbarOpen(true);
            setSnackbarMsg(response.data.message);

            editTaskLocal(response.data.data);

            let logData = {
                'title': 'Task list has been updated',
                'description': [
                    'Name: ' + response?.data?.data?.title,
                    'Property: ' + response?.data?.data?.property_name,
                    'Technician: ' + response?.data?.data?.technician_name
                ]
            }
            AddLogCallAPI(logData, token);
        }).catch(error => {
            if (typeof error.response !== 'undefined')
                toast.error(error.response.data.message);
            setLoading(false);
        });
    }

    return (<form onSubmit={handleSubmit(onSubmit)}>

        {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

        {!contentLoading && <div className={`${styles.AddprospectFirstStepForm}`}>
            <div className={`${styles.FormArea}`}>
                <div className={`${styles.AddPropertyHalfSecRow}`}>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <Controller
                            name={`title`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                id="outlined-basic"
                                label="Task name*"
                            />)}
                        />
                        {errors.title && (<p className={`${styles.ErrorM}`}>{errors?.title?.message}</p>)}
                    </div>
                    <div className={`${styles.HalfSecFull} FormGroup`}>
                        <Controller
                            name={`description`}
                            control={control}
                            render={(field) => (<TextField
                                {...field}
                                id="outlined-basic"
                                label="Description"
                                multiline
                                rows={4}
                                onChange={(e) => {
                                    field.onChange(e);

                                    setCharsLeft((prev) => {
                                        return { ...prev, description: 200 - e.target.value.length };
                                    });
                                }}
                                inputProps={{ maxLength: 200 }}
                            />)}
                        />
                        <p className={`${styles.Example}`}>{charsLeft?.description > 1 ? charsLeft?.description + " characters remaining" : charsLeft?.description + " character remaining"}</p>
                        {errors.description && (<p className={`${styles.ErrorM}`}>{errors?.description?.message}</p>)}
                    </div>
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Property</InputLabel>
                        <Controller
                            name="property_id"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Property"
                                    onChange={(e) => {
                                        field.onChange(e);

                                        let technicianListTemp = allTechnicianList?.filter(i => i?.properties?.indexOf(e?.target?.value) > -1);

                                        setTechnicianList(technicianListTemp);
                                        setValue('technicians', '');
                                    }}
                                >
                                    {propertyList?.map((item) => {
                                        return (<MenuItem value={item.value}>{item.label}</MenuItem>);
                                    })}
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.property_id && (<p className={`${styles.ErrorM}`}>{errors?.property_id?.message}</p>)}
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Technicians</InputLabel>
                        <Controller
                            name="technicians"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Technicians"
                                    onChange={(e) => {
                                        field.onChange(e);
                                    }}
                                >
                                    {technicianList.length === 0 && (<MenuItem disabled>Select Property First</MenuItem>)}
                                    {technicianList?.map(item => {
                                        return (<MenuItem key={item?.id} value={item?.id}>{item?.name}</MenuItem>)
                                    })}
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.technicians && (<p className={`${styles.ErrorM}`}>{errors.technicians.message}</p>)}
                </div>
                <div className={`${styles.HalfSecFull} FormGroup`}>
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Frequency</InputLabel>
                        <Controller
                            name="days"
                            control={control}
                            render={(field) => (
                                <Select
                                    {...field}
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    label="Frequency"
                                    multiple
                                    onChange={(e) => {
                                        field.onChange(e);

                                        if (e.target.value?.indexOf('All') > -1) {
                                            if (selectDays.length === daysList.length) {
                                                setValue('days', []);
                                                setSelectDays([]);
                                            } else {
                                                setValue('days', daysList);
                                                setSelectDays(daysList);
                                            }
                                        } else {
                                            setSelectDays(e.target.value);
                                        }
                                    }}
                                    input={<OutlinedInput label="Frequency" />}
                                    renderValue={(selected) => {
                                        return <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                                            {daysList?.map(item => {
                                                return (selected?.indexOf(item) > -1) ? (<Chip key={item} label={item} />) : null;
                                            })}
                                        </Box>
                                    }}
                                    MenuProps={MenuProps}
                                >
                                    <MenuItem value="All">
                                        <Checkbox
                                            checked={daysList.length > 0 && selectDays.length === daysList.length}
                                            indeterminate={selectDays.length > 0 && selectDays.length < daysList.length}
                                        />
                                        <ListItemText primary="Everyday" />
                                    </MenuItem>
                                    {daysList?.map(item => {
                                        return (<MenuItem key={item} value={item}>
                                            <Checkbox checked={selectDays.indexOf(item) > -1} />
                                            <ListItemText primary={item} />
                                        </MenuItem>)
                                    })}
                                </Select>
                            )}
                        />
                    </FormControl>
                    {errors.days && (<p className={`${styles.ErrorM}`}>{errors.days.message}</p>)}
                </div>
            </div>
            <div className={`${styles.ChecklistArea}`}>
                <p className={`${styles.TaskListTitle}`}>Tasks</p>
                <div className={`${styles.TasksNameListRow}`}>
                    {prevTaskList?.map((ite, ind) => {
                        return <TaskListCard2 item={ite?.task_name} index={ind} index2={ind} setTaskList={setPrevTaskList.bind(this)} editTaskOpen={activeTaskId === ind && !addTaskOpen} setActiveTaskId={setActiveTaskId.bind(this)} setAddTaskOpen={setAddTaskOpen.bind(this)} />
                    })}
                    {taskList?.map((ite2, ind2) => {
                        return <TaskListCard item={ite2} index={ind2} index2={prevTaskList?.length + ind2} setTaskList={setTaskList.bind(this)} editTaskOpen={activeTaskId === (prevTaskList?.length + ind2) && !addTaskOpen} setActiveTaskId={setActiveTaskId.bind(this)} setAddTaskOpen={setAddTaskOpen.bind(this)} />
                    })}
                </div>
                {addTaskOpen && <div className={`${styles.HalfSecFull} ${styles.DeleteBU} FormGroup`}>
                    <TextField id="outlined-basic" label="Add a Task" variant="outlined" onChange={(e) => { setTaskError(false); setTaskVal(e?.target?.value); }} />
                    {taskError && <p className={`${styles.ErrorM}`}>This field is required</p>}
                </div>}
                {addTaskOpen && <div className={`${styles.ChecklistButtonAction}`}>
                    <Button className={`${styles.AddChecklistBU}`} type="button" onClick={(e) => addTask(false)}>Add</Button>
                    <Button className={`${styles.CancelChecklistBU}`} type="button" onClick={(e) => setAddTaskOpen(false)}>Cancel</Button>
                </div>}
                {!addTaskOpen && <button className={`${styles.AddTaskListBU}`} type="button" onClick={(e) => setAddTaskOpen(true)}><Plus /> Add an Task</button>}
            </div>
            
            <div className={`${styles.ButtonAction}`}>
                <Button onClick={(e) => setEditTaskModalOpen(false)} type="button" className={`${styles.CancelPopupBU}`}>Cancel</Button>
                <Button className={`${styles.SubmitPopupBU}`} type="submit">Update</Button>
            </div>
        </div>}
    </form>);
}

export default EditTaskForm;